import React from 'react'
import ClassNames from 'classnames'
import {
  AccordionStyle,
  AccordionHeadStyle,
  AccordionBodyStyle,
  AccordionContentStyle,
  AccordionListStyle,
} from './styled'
import { Button } from '../../components'

class AccordionHead extends React.PureComponent {
  render() {
    const {
      className,
      onClick,
      children,
      isHideToggleIcon,
      onlyIconClickable,
    } = this.props

    return (
      <AccordionHeadStyle
        className={ClassNames(
          'accordion-head',
          { 'is-only-icon-clickable': onlyIconClickable },
          className
        )}
        onClick={onlyIconClickable ? undefined : onClick}
      >
        {children}

        {!isHideToggleIcon && onlyIconClickable ? (
          <Button className="link" onClick={onClick}>
            <div className="toggle-icon"></div>
          </Button>
        ) : (
          <div className="toggle-icon"></div>
        )}
      </AccordionHeadStyle>
    )
  }
}

class AccordionBody extends React.PureComponent {
  render() {
    const { className, children /*height*/ } = this.props

    return (
      <AccordionBodyStyle
        className={ClassNames('accordion-body', className)}
        /*height={height}*/
      >
        {children}
      </AccordionBodyStyle>
    )
  }
}

class AccordionContent extends React.PureComponent {
  render() {
    const { className, name, onClick } = this.props

    return (
      <AccordionContentStyle
        className={ClassNames('accordion-content', className)}
        onClick={onClick}
      >
        {name}
      </AccordionContentStyle>
    )
  }
}

class AccordionList extends React.PureComponent {
  render() {
    const { className, children } = this.props

    return (
      <AccordionListStyle className={ClassNames('accordion-list', className)}>
        {children}
      </AccordionListStyle>
    )
  }
}

export class Accordion extends React.PureComponent {
  static Head = AccordionHead
  static Body = AccordionBody
  static Content = AccordionContent
  static List = AccordionList

  constructor(props) {
    super(props)
    this.myRef = React.createRef()
    this.state = {
      bodyHeight: 0,
    }
  }

  componentDidMount() {
    this.setState({
      bodyHeight: this.myRef.current.querySelector('.accordion-body')
        .scrollHeight,
    })
  }

  componentDidUpdate() {
    this.setState({
      bodyHeight: this.myRef.current.querySelector('.accordion-body')
        .scrollHeight,
    })
  }

  render() {
    const { className, children, isOpen } = this.props

    return (
      <AccordionStyle
        innerRef={this.myRef}
        className={ClassNames('accordion', { 'is-open': isOpen }, className)}
        bodyHeight={this.state.bodyHeight}
      >
        {children}
      </AccordionStyle>
    )
  }
}
